(function() {
  var productImageObserver = 'IntersectionObserver' in window ? new IntersectionObserver(function(entries) {
    entries.forEach(function(entry) {
      if (!entry.isIntersecting) return;

      entry.target.loading = 'eager';
      productImageObserver.unobserve(entry.target);
    });
  }, { rootMargin: '3000px 0px' }) : null;

  function prepareProductImages(root) {
    if (!productImageObserver) return;

    root.querySelectorAll('.product-list--collection .product-item__primary-image[loading="lazy"]').forEach(function(image) {
      productImageObserver.observe(image);
    });
  }

  prepareProductImages(document);

  document.addEventListener('theme:loading:end', function() {
    prepareProductImages(document);
  });

})();

(function() {
  var toastLock = 0;
  var fetchPending = 0;

  function escapeHtml(value) {
    return String(value || '').replace(/[&<>"']/g, function(char) {
      return {
        '&': '&amp;',
        '<': '&lt;',
        '>': '&gt;',
        '"': '&quot;',
        "'": '&#039;'
      }[char];
    });
  }

  function getLocale() {
    return (document.documentElement.lang || 'de').toLowerCase();
  }

  function cartMessage(name) {
    var locale = getLocale();

    if (locale.indexOf('nl') === 0) {
      return name ? '<strong>' + escapeHtml(name) + '</strong> is toegevoegd aan de winkelwagen' : 'Product is toegevoegd aan de winkelwagen';
    }

    if (locale.indexOf('en') === 0) {
      return name ? '<strong>' + escapeHtml(name) + '</strong> has been added to your cart' : 'Product has been added to your cart';
    }

    return name ? '<strong>' + escapeHtml(name) + '</strong> wurde in den Warenkorb gelegt' : 'Produkt wurde in den Warenkorb gelegt';
  }

  function showToast(name) {
    if (window.theme && window.theme.cartType === 'drawer') return;

    var now = Date.now();
    if (now - toastLock < 2000) return;
    toastLock = now;

    var oldToast = document.getElementById('cart-toast-notification');
    if (oldToast) oldToast.remove();

    var toast = document.createElement('div');
    toast.id = 'cart-toast-notification';
    toast.className = 'cart-toast';
    toast.setAttribute('role', 'status');
    toast.innerHTML =
      '<div class="cart-toast__inner">' +
        '<svg class="cart-toast__icon" width="20" height="20" viewBox="0 0 24 24" fill="none" aria-hidden="true">' +
          '<circle cx="12" cy="12" r="11" stroke="#4caf50" stroke-width="2"></circle>' +
          '<polyline points="7 12 10.5 15.5 17 9" stroke="#4caf50" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></polyline>' +
        '</svg>' +
        '<span class="cart-toast__text">' + cartMessage(name) + '</span>' +
      '</div>';

    document.body.appendChild(toast);
    requestAnimationFrame(function() {
      toast.classList.add('cart-toast--visible');
    });

    setTimeout(function() {
      toast.classList.remove('cart-toast--visible');
      setTimeout(function() {
        if (toast.parentNode) toast.remove();
      }, 400);
    }, 4000);
  }

  try {
    var originalFetch = window.fetch;

    window.fetch = function() {
      var args = arguments;
      var request = args[0];
      var url = typeof request === 'string' ? request : request && request.url ? request.url : '';
      var options = args[1] || {};
      var method = (options.method || 'GET').toUpperCase();
      var promise = originalFetch.apply(this, args);

      if (method === 'POST' && url.indexOf('/cart/add') !== -1) {
        fetchPending = Date.now();

        promise.then(function(response) {
          if (!response.ok) {
            fetchPending = 0;
            return;
          }

          response.clone().json().then(function(data) {
            var name = null;
            fetchPending = 0;

            if (data && data.items && data.items.length) {
              name = data.items[0].title || data.items[0].product_title;
            } else if (data) {
              name = data.title || data.product_title;
            }

            showToast(name);
          }).catch(function() {
            fetchPending = 0;
            showToast(null);
          });
        }).catch(function() {
          fetchPending = 0;
        });
      }

      return promise;
    };
  } catch (error) {}

  function onProductAdded(event) {
    if (event.detail && event.detail.productAdded === false) return;
    if (fetchPending && Date.now() - fetchPending < 5000) return;

    var name = null;
    var button = event.detail && event.detail.button;

    if (button) {
      var card = button.closest('.product-item');
      var section = button.closest('[data-section-type="product"]');
      var cardTitle = card && card.querySelector('.product-item__title');
      var productTitle = section && section.querySelector('.product-meta__title');

      name = cardTitle && cardTitle.textContent.trim() || productTitle && productTitle.textContent.trim() || null;
    }

    if (!name) {
      var title = document.querySelector('.product-meta__title');
      if (title) name = title.textContent.trim();
    }

    showToast(name);
  }

  document.addEventListener('product:added', onProductAdded);
  document.documentElement.addEventListener('product:added', onProductAdded);
})();

(function() {
  var modal = null;
  var lastFocus = null;
  var previousBodyOverflow = '';

  var translations = {
    de: {
      title: 'Muster bestellen',
      intro: 'Naturstein ist ein Unikat - jedes Stück variiert in Farbe, Maserung und Struktur. Mit einem Muster können Sie die Optik und Haptik des Materials vor dem Kauf erleben und die perfekte Variante für Ihr Projekt auswählen.',
      size: 'Muster ca. 20×20 cm',
      feat1: 'Sie erhalten zu jedem bestellten 1. Muster einer Sorte ein weiteres Musterstück kostenlos dazu',
      feat2: 'Farbe und Haptik vor dem Kauf prüfen',
      feat3: 'Kostenloser Versand',
      tax: 'inkl. MwSt.',
      btn: 'Muster in den Warenkorb',
      adding: 'Wird hinzugefügt...',
      added: 'Hinzugefügt!',
      error: 'Fehler - erneut versuchen',
      close: 'Schließen'
    },
    nl: {
      title: 'Monster bestellen',
      intro: 'Natuursteen is uniek - elk stuk varieert in kleur, nerven en structuur. Met een monster kunt u de uitstraling en textuur van het materiaal voor aankoop ervaren en de perfecte variant voor uw project kiezen.',
      size: 'Monster ca. 20×20 cm',
      feat1: 'U ontvangt bij elk 1e besteld monster van een soort een extra monster gratis',
      feat2: 'Kleur en textuur voor aankoop controleren',
      feat3: 'Gratis verzending',
      tax: 'incl. btw',
      btn: 'Monster in winkelwagen',
      adding: 'Wordt toegevoegd...',
      added: 'Toegevoegd!',
      error: 'Fout - probeer opnieuw',
      close: 'Sluiten'
    },
    en: {
      title: 'Order Sample',
      intro: 'Natural stone is unique - each piece varies in color, veining, and structure. With a sample, you can experience the look and feel of the material before purchase and choose the perfect variant for your project.',
      size: 'Sample approx. 20×20 cm',
      feat1: 'You receive an additional sample piece free with every 1st sample of a type ordered',
      feat2: 'Check color and texture before purchase',
      feat3: 'Free shipping',
      tax: 'incl. VAT',
      btn: 'Add sample to cart',
      adding: 'Adding...',
      added: 'Added!',
      error: 'Error - try again',
      close: 'Close'
    }
  };

  function t(locale) {
    return translations[locale] || translations.de;
  }

  function createModal() {
    var element = document.createElement('div');
    element.id = 'sample-modal-shared';
    element.className = 'sample-modal';
    element.setAttribute('role', 'dialog');
    element.setAttribute('aria-modal', 'true');
    element.innerHTML =
      '<div class="sample-modal__dialog">' +
        '<header class="sample-modal__header">' +
          '<h2 class="sample-modal__title"></h2>' +
          '<button type="button" class="sample-modal__close" aria-label="Schließen"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" aria-hidden="true"><line x1="18" y1="6" x2="6" y2="18"></line><line x1="6" y1="6" x2="18" y2="18"></line></svg></button>' +
        '</header>' +
        '<div class="sample-modal__content">' +
          '<div class="sample-intro"><p class="sample-intro__text"></p></div>' +
          '<div class="sample-card">' +
            '<h3 class="sample-card__title"></h3>' +
            '<ul class="sample-card__features"><li></li><li></li><li></li></ul>' +
            '<p class="sample-card__price"><span class="sample-card__price-value">€5,95</span> <span class="sample-card__price-tax"></span></p>' +
            '<button class="button button--primary sample-card__button"></button>' +
          '</div>' +
        '</div>' +
      '</div>';
    document.body.appendChild(element);
    return element;
  }

  function sampleUrlFromProductUrl(productUrl, sampleUrlParts) {
    var parts = sampleUrlParts.split('|');

    if (!productUrl || parts.length < 3) {
      return null;
    }

    if (productUrl.indexOf('/nl/') !== -1 || productUrl.indexOf('/en/') !== -1) {
      if (parts.length < 4) return null;
      return '/' + parts[1] + '/' + parts[2] + '/muster-' + parts[3];
    }

    return '/' + parts[1] + '/muster-' + parts[2];
  }

  function openModal(trigger) {
    var locale = trigger.dataset.locale || 'de';
    var text = t(locale);
    var sampleUrl = sampleUrlFromProductUrl(trigger.dataset.productUrl, trigger.dataset.sampleUrlParts || '');

    if (!sampleUrl) return;
    if (!modal) modal = createModal();

    modal.querySelector('.sample-modal__title').textContent = text.title;
    modal.querySelector('.sample-modal__close').setAttribute('aria-label', text.close);
    modal.querySelector('.sample-intro__text').textContent = text.intro;
    modal.querySelector('.sample-card__title').textContent = text.size;
    modal.querySelector('.sample-card__price-tax').textContent = text.tax;

    var listItems = modal.querySelectorAll('.sample-card__features li');
    listItems[0].textContent = text.feat1;
    listItems[1].textContent = text.feat2;
    listItems[2].textContent = text.feat3;

    var button = modal.querySelector('.sample-card__button');
    button.textContent = text.btn;
    button.disabled = false;
    button.classList.remove('is-loading');
    button.dataset.locale = locale;
    button.dataset.sampleUrl = sampleUrl;

    lastFocus = document.activeElement;
    previousBodyOverflow = document.body.style.overflow;
    modal.classList.add('is-open');
    document.body.style.overflow = 'hidden';
    modal.querySelector('.sample-modal__close').focus();
  }

  function closeModal() {
    if (!modal) return;

    modal.classList.remove('is-open');
    document.body.style.overflow = previousBodyOverflow;

    if (lastFocus) lastFocus.focus();
  }

  function resetButton(button, text) {
    button.textContent = text.btn;
    button.disabled = false;
    button.classList.remove('is-loading');
  }

  document.addEventListener('click', function(event) {
    var trigger = event.target.closest('[data-action="open-sample-modal-card"]');

    if (trigger) {
      event.preventDefault();
      event.stopPropagation();
      openModal(trigger);
      return;
    }

    if (!modal) return;

    if (event.target.closest('.sample-modal__close') || event.target === modal) {
      closeModal();
    }
  });

  document.addEventListener('keydown', function(event) {
    if (event.key === 'Escape' && modal && modal.classList.contains('is-open')) {
      closeModal();
    }
  });

  document.addEventListener('click', function(event) {
    var button = event.target.closest('#sample-modal-shared .sample-card__button');

    if (!button) return;

    event.preventDefault();

    var text = t(button.dataset.locale || 'de');
    var sampleUrl = button.dataset.sampleUrl;

    button.classList.add('is-loading');
    button.disabled = true;
    button.textContent = text.adding;

    fetch(sampleUrl, { method: 'HEAD', redirect: 'follow' })
      .then(function(response) {
        return fetch(response.url.split('?')[0] + '.js');
      })
      .then(function(response) {
        if (!response.ok) throw new Error('Sample product not found');
        return response.json();
      })
      .then(function(sample) {
        if (!sample.variants || !sample.variants.length) throw new Error('Sample variant not found');

        return fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: sample.variants[0].id, quantity: 1 })
        });
      })
      .then(function(response) {
        if (!response.ok) throw new Error('Sample add failed');
        return response.json();
      })
      .then(function() {
        button.textContent = text.added;
        closeModal();

        fetch('/cart.js').then(function(response) {
          return response.json();
        }).then(function(cart) {
          document.querySelectorAll('[data-cart-count], .cart-count, .header__cart-count').forEach(function(counter) {
            counter.textContent = cart.item_count;
          });
        });

        document.documentElement.dispatchEvent(new CustomEvent('product:added', {
          bubbles: true,
          detail: { quantity: 1, productAdded: true }
        }));

        setTimeout(function() {
          resetButton(button, text);
        }, 1200);
      })
      .catch(function(error) {
        console.error('Sample add error:', error);
        button.textContent = text.error;
        button.classList.remove('is-loading');

        setTimeout(function() {
          resetButton(button, text);
        }, 1500);
      });
  });
})();
